<template>
	<div class="chargeewm">
		<div v-title data-title="支付"></div>
		<el-row style="margin-top:10%">
			<el-col :span="8" style="color:transparent">
				1
			</el-col>
			<el-col :span="8">
				<el-card class="box-card" style="text-align:center;">
				  <div slot="header" class="clearfix">
				    <p>请使用{{p_paytype}}扫描二维码支付</p>
				  </div>
				  <div v-if="chargeewm!=''">
					  <p style="font-size:10pt;color:#FF9317">交易将在{{time}}分钟后失效，请尽快扫码支付</p>
					  <br/>
					  <el-image :src="chargeewm" fit="fill" style="width:200px"></el-image>
				  </div>
				  <div v-else style="text-align: center;height:200px;">
					  <el-image style="width:200px">
						  <div slot="error" class="image-slot">
						        <p style="color:#a3a3a3">{{errormsg}}</p>
						   </div>
					  </el-image>
				  </div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>
<script>
export default {
	components: {
	},
	data() {
		return {
			chargeewm:'',
			payno:'',
			p_paytype:'',
			divclass:'chargeewm',
			time:5,
			errormsg:'',
			startime:'',
			endtime:''
		};
	},
	mounted() {
		console.log('加载支付二维码');
		this.$tool.loading('正在生成');
		this.createewm();
	},
	methods: {
		//点击确认支付调起后台支付
		createewm() {
			var that = this;
			var payparam =localStorage.getItem('payparam');
			console.log('payparam',payparam);
			if(payparam!=undefined){
				payparam=JSON.parse(payparam);
				that.p_paytype=payparam.p_paytype;
				this.$apipost.post.VipCharge({ payparam:payparam }).then(res => {
					console.log('充值信息',res);
					this.$tool.loadingclose();
					if (res.state == '1') {
						that.chargeewm = res.ewm;
						that.payno = res.sn;
						localStorage.setItem('payno',that.payno);
						if(that.chargeewm!=undefined&&that.chargeewm!=''){
							that.startime=new Date().getTime();
							this.timer = window.setInterval(() => {
								setTimeout(() => {
									that.checkchargestate()
								},0)
							},8000);
						}else
							that.errormsg='生成充值二维码失败';
					}
					else{
						that.errormsg=res.message;
					}
				});
			}else{
				this.$tool.loadingclose();
			}
		},
		//确认支付
		checkchargestate() {
			var that = this;
			if(this.checklimittime()){
				var payparam = {
						p_paytype: this.p_paytype,
						sn: this.payno
					};
					this.$apipost.get.getpayorder({ payparam: payparam }).then(res => {
						this.$tool.loadingclose();
						if (res.state == '1') {
							this.$tool.message('充值成功', 1);
							that.destroyed();
						}
					});
			}else{
				 window.clearInterval(this.timer);
				 that.chargeewm='';
				 that.errormsg='二维码已过期';
			}
		},
		destroyed() {
		   //console.log('支付成功，关闭窗口');
		   localStorage.removeItem('payparam');//移除支付参数
		   localStorage.setItem('paystate','1');
		   window.clearInterval(this.timer);
		   setTimeout(function(){
				window.opener = null;
				window.open("about:blank", "_top").close();
		   },2000);
		},
		//检测
		checklimittime(){
			this.endtime=new Date().getTime();
			var diffValue = this.endtime-this.startime;
			var minute = 1000 * 60;
			var hour = minute * 60;
			var day = hour * 24;
			var halfamonth = day * 15;
			var month = day * 30;
	
			var monthC =diffValue/month;
			var weekC =diffValue/(7*day);
			var dayC =diffValue/day;
			var hourC =diffValue/hour;
			var minC =diffValue/minute;
			console.log('分钟',minC);
			if (parseInt(monthC) >=1||parseInt(dayC) >= 1||parseInt(hourC)>=1||parseInt(minC)>=this.time) {
			return false;
		}else
			return true;
		}
	}
}
</script>

<style>
</style>
